// Material UI Library
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import FormHelperText from '@mui/material/FormHelperText';

// Translation Library
import { useTranslation } from 'react-i18next';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const hearAboutUsOptionsEn = {
  personal_invitations: "Personal Invitations",
  social_media_platforms: "Social Media Platforms",
  street_banners: "Road Advertisements",
  internet: "Websites",
  other: "Other"
};


const hearAboutUsOptionsAr = {
  personal_invitations: "دعوة شخصية",
  social_media_platforms: "وسائل التواصل الاجتماعي",
  street_banners: "إعلانات طرقية",
  internet: "مواقع الكترونية",
  other: "أخرى"
};

// make the object as Array and take the keys [key1, key2, key3,...]
const hearAboutUsEn = Object.keys(hearAboutUsOptionsEn);
const hearAboutUsAr = Object.keys(hearAboutUsOptionsAr);

export default function HearAboutUs({formData, handleChange, errorsData}) {
    const { t,i18n } = useTranslation();

  return (
    <>
      <FormControl className="w-full">
        <InputLabel error={errorsData.heard_about_us}>{t("heard_about_us")}</InputLabel>
        <Select
            error={errorsData.heard_about_us}
            name='heard_about_us'
            value={formData.heard_about_us}
            onChange={handleChange}
            input={<OutlinedInput label={t("heard_about_us")} />}
            renderValue={(selected) =>{
              return selected ? (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {i18n.language === "en" ? <Chip label={hearAboutUsOptionsEn[selected]} /> : <Chip label={hearAboutUsOptionsAr[selected]} />}
                  </Box>
              ) : (
                  <></>
              )}
            }
            MenuProps={MenuProps}
        >
        {i18n.language === "en" 
        ?(
          hearAboutUsEn.map((key) => (
            <MenuItem key={key} value={key}>
              {hearAboutUsOptionsEn[key]}
            </MenuItem>
          ))
        )
        :(
          hearAboutUsAr.map((key) => (
            <MenuItem key={key} value={key}>
              {hearAboutUsOptionsAr[key]}
            </MenuItem>
          ))
        )
        }
        </Select>
        {errorsData.heard_about_us ? (
        <FormHelperText sx={{ color: 'error.main' }}>{t("please_select_one_of_how_did_you_hear_about_us")}</FormHelperText>
        ): ""}
      </FormControl>
    </>
  );
}
